module.exports = __webpack_public_path__ + "static/media/lds-logo_et.7a91aecb.svg";